import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var FileSave = require("file-saver");
export default {
  name: "",
  components: {},
  props: {
    api: {
      type: String,
      default: process.env.VUE_APP_FILE_URL_API + "/fsevice/uploadFile"
    },
    multiple: {
      //是否多选
      type: Boolean,
      default: true
    },
    isShowFileName: {
      type: Boolean,
      default: false
    },
    disabled: {
      default: false,
      type: Boolean
    },
    fileList: {
      // 初始值，字符串数组
      type: Array,
      default: function _default() {
        return [];
      }
    },
    limit: {
      // 最多可上传多少张
      type: Number,
      default: function _default() {
        return 9999;
      }
    },
    fileType: {
      // 限制的图片类型，字符串数组，例如['.gif', '.png']
      type: Array,
      default: function _default() {
        return [];
      }
    },
    maxSize: {
      // 可上传文件的最大值, 单位是M
      type: Number,
      default: function _default() {
        return 9999;
      }
    }
  },
  data: function data() {
    return {
      showfileList: [],
      fileImportUrl: process.env.VUE_APP_FILE_URL_API + "/fsevice/uploadFile",
      //文件上传路径
      dialogImageUrl: "",
      //预览地址
      dialogVisible: false,
      //对话框标识
      tv_id: "",
      //上传的类型
      docxImg: require("../../assets/images/word.png"),
      //word封面
      xlsxImg: require("../../assets/images/excel.png"),
      //excel 封面
      pdfImg: require("../../assets/images/pdf.png"),
      //excel 封面
      postFileLists: [],
      //传给前台的文件列表
      videoUrl: "",
      //下载的地址
      videoPic: "",
      uploadDisabled: false,
      pdfFlag: false,
      fileName: ""
    };
  },
  computed: {},
  watch: {
    fileList: {
      handler: function handler(newVal) {
        this.init();
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    handleChange: function handleChange(file, fileList) {},
    init: function init() {
      var _this = this;
      this.postFileLists = [];
      var index;
      var fileType;
      this.showfileList = [];
      this.uploadDisabled = false;
      if (this.fileList.length > 0) {
        if (this.fileList.length >= this.limit) {
          this.uploadDisabled = true;
        }
        this.showfileList = this.fileList.map(function (item) {
          index = item.sourceUrl.lastIndexOf("."); //（考虑严谨用lastIndexOf(".")得到）得到"."在第几位
          fileType = item.sourceUrl.substring(index).toLowerCase();
          if (fileType == ".xlsx" || fileType == ".xls") {
            item.url = _this.xlsxImg;
          } else if (fileType == ".docx" || fileType == ".doc") {
            item.url = _this.docxImg;
          } else if (fileType == ".mp4") {
            item.url = item.videoUrl;
          } else if (fileType == ".pdf") {
            item.url = _this.pdfImg;
          } else {
            item.url = item.sourceUrl;
          }
          if (_this.isShowFileName) {
            _this.postFileLists.push({
              sourceUrl: item.sourceUrl,
              name: item.name
            });
          } else {
            _this.postFileLists.push(item.sourceUrl);
          }
          return {
            name: item.name,
            url: item.url,
            videoFlag: false,
            response: {
              data: {
                name: item.name,
                fullPath: item.sourceUrl
              }
            }
          };
        });
      }
    },
    handleOverLimit: function handleOverLimit(files, fileList) {
      this.$message.warning("\u4E0A\u4F20\u6587\u4EF6\u6216\u56FE\u7247\u4E0D\u80FD\u8D85\u8FC7".concat(this.limit, "\u4EFD"));
    },
    clearFiles: function clearFiles(callback) {
      this.$refs.pictureUpload.clearFiles(callback);
    },
    //上传失败事件
    uploadError: function uploadError() {
      this.$message.error("上传失败");
    },
    //上传成功事件
    uploadSuccess: function uploadSuccess(response, file, fileList) {
      var fileUrl = response.data.fullPath;
      if (fileList.length >= this.limit) {
        this.uploadDisabled = true;
      }
      if (response.message === "success") {
        this.$message.success("上传成功");
        file.videoFlag = false;
        this.videoUploadPercent = 0;
      } else {
        //上传失败的时候需要删除传输列表
        this.$message.warning(response.message);
        this.$refs.pictureUpload.handleRemove(file);
        var removeFile = file.response.data.fullPath;
        this.postFileLists = this.postFileLists.filter(function (item) {
          return item !== removeFile;
        });
        return;
      }
      var index = file.name.lastIndexOf("."); //（考虑严谨用lastIndexOf(".")得到）得到"."在第几位
      this.tv_id = file.name.substring(index).toLowerCase(); //截断"."之前的，得到后缀
      this.videoUrl = fileUrl;

      //如果是视频截取第一个作为图片展示出来
      if (this.tv_id == ".mp4") {
        //根据后缀，判断是否符合视频格式
        this.findvideocover(response.data.fullPath, file);
      } else if (this.tv_id == ".xlsx" || this.tv_id == ".xls") {
        file.url = this.xlsxImg;
      } else if (this.tv_id == ".docx" || this.tv_id == ".doc") {
        file.url = this.docxImg;
      } else if (this.tv_id == ".pdf") {
        file.url = this.pdfImg;
      }
      if (this.isShowFileName) {
        this.fileName = file.name;
        this.postFileLists.push({
          sourceUrl: fileUrl,
          name: file.name
        });
      } else {
        this.postFileLists.push(fileUrl);
      }
      this.$emit("getFilePath", this.postFileLists, this.videoPic);
    },
    beforeUpload: function beforeUpload(file) {
      //判断类别和大小
      var judge1 = true;
      if (this.fileType.length > 0) {
        var index = file.name.lastIndexOf("."); //（考虑严谨用lastIndexOf(".")得到）得到"."在第几位
        var fileType = file.name.substring(index).toLowerCase();
        var flag = this.fileType.includes(fileType);
        if (flag) {
          judge1 = true;
        } else {
          judge1 = false;
        }
      }
      var judge2 = file.size <= this.maxSize * 1024 * 1024;
      if (!judge1) {
        this.$message.error("请上传" + this.fileType.join("、") + "类型的图片或者文件");
        return false;
      }
      if (!judge2) {
        if (this.limit == 1) {
          this.$message.error("图片大小不能超过" + this.maxSize + "M");
        } else {
          this.$message.error("单个文件最大可上传" + this.maxSize + "M");
        }
        return false;
      }
    },
    handleRemove: function handleRemove(file) {
      var _this2 = this;
      //删除文件
      var removeFile = file.response.data.fullPath;
      var postFileLists = [];
      this.$refs.pictureUpload.handleRemove(file);
      if (this.isShowFileName) {
        postFileLists = this.postFileLists.filter(function (item) {
          return item.sourceUrl !== removeFile;
        });
        this.postFileLists.forEach(function (item, index) {
          if (item.sourceUrl === removeFile) {
            _this2.postFileLists.splice(index, 1);
          }
        });
      } else {
        postFileLists = this.postFileLists.filter(function (item) {
          console.log(item === removeFile);
          return item !== removeFile;
        });
        this.postFileLists.forEach(function (item, index) {
          if (item === removeFile) {
            _this2.postFileLists.splice(index, 1);
          }
        });
      }
      this.uploadDisabled = false;
      this.$emit("getFilePath", postFileLists, this.videoPic);
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      console.log(file);
      var index = file.response.data.fullPath.lastIndexOf(".");
      var fileType = file.response.data.fullPath.substring(index).toLowerCase();
      if (fileType === ".pdf") {
        this.pdfFlag = true;
        this.dialogImageUrl = file.response.data.fullPath;
      } else {
        this.pdfFlag = false;
        this.dialogImageUrl = file.url;
      }
      this.dialogVisible = true;
    },
    handleDownload: function handleDownload(file) {
      this.videoUrl = file.response.data.fullPath;
      var index = file.response.data.fullPath.lastIndexOf("."); //（考虑严谨用lastIndexOf(".")得到）得到"."在第几位
      var fileType = file.response.data.fullPath.substring(index).toLowerCase(); //截断"."之前的，得到后缀
      //动态创建a标签,下载文件
      var a = document.createElement("a");
      a.setAttribute("download", "");
      a.setAttribute("target", "_blank");
      a.setAttribute("id", "a____startTelMedicine");
      if (fileType === ".png" || fileType === ".jpg" || fileType === ".gif") {
        a.setAttribute("href", file.url);
      } else if (fileType === ".pdf") {
        var oReq = new XMLHttpRequest();
        var URLToPDF = file.response.data.fullPath;
        oReq.open("GET", URLToPDF, true);
        oReq.responseType = "blob";
        oReq.onload = function () {
          var files = new Blob([oReq.response], {
            type: "application/pdf"
          });
          FileSave.saveAs(files, file.name);
        };
        oReq.send();
      } else {
        //根据后缀，判断是否符合视频格式,如果是视频或者文件,不能让它下载这个封面,而是下载视频或者文件本身的地址
        a.setAttribute("href", this.videoUrl);
      }

      // 防止反复添加
      if (document.getElementById("a____startTelMedicine")) {
        document.body.removeChild(document.getElementById("a____startTelMedicine"));
      }
      document.body.appendChild(a);
      a.click();
    },
    findvideocover: function findvideocover(url, file) {
      var _this3 = this;
      var videoDom = document.createElement("video");
      videoDom.onloadedmetadata = function (evt) {
        URL.revokeObjectURL(url);
        videoDom.width = videoDom.videoWidth;
        videoDom.height = videoDom.videoHeight;
      };
      videoDom.setAttribute("crossOrigin", "Anonymous");
      videoDom.setAttribute("controls", "controls");
      videoDom.setAttribute("autoplay", "autoplay");
      videoDom.volume = 0;
      videoDom.setAttribute("src", url); // 视频的链接
      document.getElementById("upload_wrapper").appendChild(videoDom);
      videoDom.style.visibility = "hidden";
      var canvas = document.createElement("canvas");
      document.body.appendChild(canvas);
      canvas.style.display = "none";
      var ctx = canvas.getContext("2d"); // 绘制2d

      videoDom.crossOrigin = "anonymous"; // 解决跨域问题，也就是提示污染资源无法转换视频
      videoDom.currentTime = 12; // 第一帧
      videoDom.oncanplay = function () {
        canvas.width = videoDom.clientWidth; // 获取视频宽度
        canvas.height = videoDom.clientHeight; //获取视频高度
        // 利用canvas对象方法绘图
        ctx.drawImage(videoDom, 0, 0, videoDom.clientWidth, videoDom.clientHeight);
        videoDom.width = "0"; //清除掉视频高度,防止在页面占据高度
        videoDom.height = "0";
        // 转换成base64形式
        file.url = canvas.toDataURL("image/png"); // 截取后的视频封面
        _this3.$emit("getFilePath", _this3.postFileLists, file.url);
      };
    },
    //上传文件控制进度
    uploadVideoProcess: function uploadVideoProcess(event, file) {
      //文件上传只能让对应的进度表转动
      file.videoFlag = true;
      this.videoUploadPercent = Number(event.percent.toFixed(0));
    }
  }
};